import { cellKeyOf } from "../cellKeyOf";
import type { PlanCellKeyOf } from "./types";

export const planCellKeyOf: PlanCellKeyOf = ({ plan }) =>
  plan.building === null || plan.level === null
    ? null
    : cellKeyOf({ buildingCode: plan.building, levelCode: plan.level });
